import * as React from 'react';

const InfoChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 6c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6zm0 14c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8 3.6 8 8 8z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 8h2v2h-2zM11 11h2v5h-2z"
        />
    </svg>
);

InfoChunkySvg.displayName = 'InfoChunkySvg';
export default InfoChunkySvg;
